
export default {
	name: "CrosswordClueList",
	props: {
		clues: {
			type: Array,
			required: true,
		},
	},
};
